import { z } from "zod";
import { LinkAsLink, linkAsLinkSchema } from "@made-people/blueprint-link";
import { withManagedProps } from "@made-people/managed-props";
import { withZod } from "@made-people/react-prop-guard";
import { OpenLinkInModal } from "./open-link-in-modal";

export const checkoutInformationCardSchema = z.object({
  text: z.string().optional(),
  openModal: z.boolean().optional(),
  link: linkAsLinkSchema.shape.link.optional(),
  linkLabel: z.string().optional(),
});

export type CheckoutInformationCardProps = z.infer<
  typeof checkoutInformationCardSchema
>;

const CheckoutInformationCardComponent = ({
  text,
  openModal,
  link,
  linkLabel,
}: CheckoutInformationCardProps) => {
  if (!text) {
    return null;
  }

  const modalHref = link?.href;
  const shouldOpenModal = Boolean(openModal && modalHref);

  return (
    <div
      className="w-full bg-primary/20 border rounded-md px-4 py-3 text-center mb-4 text-body-md mt-6 flex flex-col items-center justify-center lg:mt-0 lg:mb-10 gap-2"
      role="alert"
      aria-live="polite"
    >
      {text}
      {link &&
        modalHref &&
        (shouldOpenModal ? (
          <OpenLinkInModal
            href={modalHref}
            label={linkLabel}
            title={linkLabel ?? text}
            variants={{ size: "md" }}
          />
        ) : (
          <LinkAsLink link={link} variants={{ size: "md" }} label={linkLabel} />
        ))}
    </div>
  );
};

export const CheckoutInformationCard = withManagedProps(
  "CheckoutInformationCard",
  withZod(checkoutInformationCardSchema, CheckoutInformationCardComponent),
);
